import { render, staticRenderFns } from "./Coin.vue?vue&type=template&id=55e4520a&scoped=true&"
import script from "./Coin.vue?vue&type=script&lang=ts&"
export * from "./Coin.vue?vue&type=script&lang=ts&"
import style0 from "./Coin.vue?vue&type=style&index=0&id=55e4520a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e4520a",
  null
  
)

export default component.exports